import React, { Component } from "react";
import "./ProjectPage.css";

class ProjectPage extends Component {
  render() {
    return <div></div>;
  }
}

export default ProjectPage;
